import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { HERO_SLIDES } from '../mock';
import { Button } from './ui/button';

const HeroSlider = () => {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx(i => (i + 1) % HERO_SLIDES.length), 5500);
    return () => clearInterval(t);
  }, []);

  const slide = HERO_SLIDES[idx];

  return (
    <div className="relative w-full bg-neutral-100 overflow-hidden">
      <div className="relative w-full" style={{ aspectRatio: '21/9', maxHeight: '560px' }}>
        {HERO_SLIDES.map((s, i) => (
          <div key={s.id} className={`absolute inset-0 transition-opacity duration-700 ${i === idx ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
            <img src={s.image} alt={s.title} className="w-full h-full object-cover" />
            <div className="absolute inset-0 flex items-end md:items-center justify-start">
              <div className="max-w-7xl mx-auto w-full px-6 md:px-12 pb-10 md:pb-0">
                <div className="max-w-xl">
                  <Link to={`/shop?brand=${s.brand}`}>
                    <Button size="lg" className="bg-[#bfff00] hover:bg-[#a8e600] text-black font-bold uppercase tracking-wider px-8 shadow-lg">Shop Now</Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}

        <button onClick={() => setIdx(i => (i - 1 + HERO_SLIDES.length) % HERO_SLIDES.length)} className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/80 hover:bg-white shadow flex items-center justify-center transition-colors" aria-label="Previous">
          <ChevronLeft className="w-5 h-5" />
        </button>
        <button onClick={() => setIdx(i => (i + 1) % HERO_SLIDES.length)} className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/80 hover:bg-white shadow flex items-center justify-center transition-colors" aria-label="Next">
          <ChevronRight className="w-5 h-5" />
        </button>

        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
          {HERO_SLIDES.map((_, i) => (
            <button key={i} onClick={() => setIdx(i)} className={`h-2 rounded-full transition-all ${i === idx ? 'bg-[#bfff00] w-8' : 'bg-white/70 w-2'}`} aria-label={`Slide ${i + 1}`} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default HeroSlider;
